const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

// Custom animation
/**
 * PANTUTI — Scroll Reveal
 * Dùng IntersectionObserver — không cần thư viện ngoài
 *
 * Cách dùng:
 *   1. Upload file này vào assets/
 *   2. Trong layout/theme.liquid, trước </body>:
 *      <script src="{{ 'scroll-reveal.js' | asset_url }}" defer></script>
 *
 * ── Reveal đơn lẻ ──────────────────────────────────────────────
 *   Thêm class vào element bất kỳ:
 *     .reveal        → fade + slide lên từ dưới
 *     .reveal-left   → fade + slide từ trái
 *     .reveal-scale  → fade + scale nhỏ → bình thường
 *
 * ── Stagger (tự động cho children) ────────────────────────────
 *   Thêm .stagger vào element CHA — script tự gán delay cho từng con:
 *     <ul class="stagger">
 *       <li>...</li>   ← delay 0ms
 *       <li>...</li>   ← delay 80ms
 *       <li>...</li>   ← delay 160ms
 *     </ul>
 *
 *   Mặc định con dùng .reveal (slide lên). Override bằng data attribute:
 *     <ul class="stagger" data-stagger-type="scale">   → reveal-scale
 *     <ul class="stagger" data-stagger-type="left">    → reveal-left
 *     <ul class="stagger" data-stagger-type="fade">    → reveal (mặc định)
 *
 *   Tuỳ chỉnh delay giữa các item (ms):
 *     <ul class="stagger" data-stagger-delay="120">
 */

(function () {
  'use strict';

  var REVEAL_SELECTORS = ['.reveal', '.reveal-left', '.reveal-scale'];
  var STAGGER_DELAY    = 80;   // ms mặc định giữa các item
  var MAX_DELAY        = 600;  // ms — không delay quá lâu dù có nhiều item

  var TYPE_CLASS = {
    'fade'  : 'reveal',
    'left'  : 'reveal-left',
    'scale' : 'reveal-scale',
  };

  // ── Khởi tạo stagger cha → gán class + delay cho con ──────────
  function initStagger(parent) {
    var type     = parent.dataset.staggerType  || 'fade';
    var delay    = parseInt(parent.dataset.staggerDelay || STAGGER_DELAY, 10);
    var cls      = TYPE_CLASS[type] || 'reveal';
    var children = Array.from(parent.children);

    children.forEach(function (child, i) {
      child.classList.add(cls);
      var d = Math.min(i * delay, MAX_DELAY);
      child.style.transitionDelay = d + 'ms';
    });
  }

  // ── IntersectionObserver cho reveal đơn lẻ ────────────────────
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  // ── IntersectionObserver cho stagger cha ──────────────────────
  // Khi cha vào viewport → thêm .visible cho tất cả con cùng lúc
  // CSS transition-delay lo phần còn lại
  var staggerObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          Array.from(entry.target.children).forEach(function (child) {
            child.classList.add('visible');
          });
          staggerObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -20px 0px',
    }
  );

  // ── Gắn observer cho toàn bộ DOM ──────────────────────────────
  function observeAll() {
    // Stagger parents — xử lý trước để class được gán trước khi observe reveal
    document.querySelectorAll('.stagger').forEach(function (parent) {
      initStagger(parent);
      staggerObserver.observe(parent);
    });

    // Reveal đơn lẻ
    REVEAL_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // Bỏ qua nếu element là con của .stagger (đã xử lý ở trên)
        if (!el.closest('.stagger')) {
          revealObserver.observe(el);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-observe khi Shopify load section mới qua AJAX
  document.addEventListener('shopify:section:load', observeAll);
})();
